import React, { useEffect, useState } from 'react';
import { Box, Flex, Text, Image } from '@chakra-ui/react';
import MyDiv from './checkInOutCard.style';
import ClockIcon from '../../../../assets/images/Clock.svg';
import { CustomToast } from '../../../../components';
import { useFetch } from '../../../../hooks/useFetch';



const formatDate = (date: Date) =>
  date.toLocaleDateString('en-US', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });

const CheckInOutCard = () => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [workingHours, setWorkingHours] = useState('00 Hrs:00 Min');


  const loadTotalWorkingHours = async () => {
    const response = await fetchApi("Dashboard/employeeTotalWorkingHour", "GET", "", "", "");
    if (response && typeof response.totalWorkedHours === "number") {
      const hours = Math.floor(response.totalWorkedHours);
      const minutes = Math.round((response.totalWorkedHours - hours) * 60);
      setWorkingHours(`${hours} hrs ${minutes} min`);
    }
  }


  useEffect(() => {
    loadTotalWorkingHours();
  }, [])

  return (
    <MyDiv>
      <Flex direction="column" gap={2}>
        <Box className="checkinCard">
          <Flex className="checkinContent" direction={{ base: 'column', md: 'row' }} align="center" justify="space-between">
            <Flex align="center" gap={4}>
              <Image src={ClockIcon} alt="Clock Icon" className="clockIcon" />
              <Box>
                <Text className="date font-poppins text_medium text_md">Today - {formatDate(new Date())}</Text>
              </Box>
            </Flex>
            <Flex align="center" gap={6} mt={{ base: 4, md: 0 }}>
              <Box>
                <Text className="hoursLabel font-poppins text_medium text_lg common_color">Total Working Hrs</Text>
                <Text className="hoursValue font-poppins text_medium text_md">{workingHours}</Text>
              </Box>
            </Flex>
          </Flex>
        </Box>
      </Flex>
    </MyDiv>
  );
};

export default CheckInOutCard;
